import httpClient from "http-client/http-client";

export async function createPortalEvent(body) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/event",
    body,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function updatePortalEvent(eventId, body) {
  const { data, errors } = await httpClient.put({
    url: `v1/community-portal/event/${eventId}`,
    body,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function listPortalEvents(params = {}) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/event/list",
    body: params,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function getPortalEventDetail(eventId) {
  const { data, errors } = await httpClient.get({
    url: `v1/community-portal/event/${eventId}`,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function publishPortalEvent(eventId) {
  const { data, errors } = await httpClient.post({
    url: `v1/community-portal/event/${eventId}/publish`,
    body: {},
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

export async function getEventAttendees({
  eventIds,
  current_page = 1,
  page_size = 20,
}) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/event/event-attendees",
    body: { event_ids: eventIds, current_page, page_size },
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

/**
 * Fetches inventory counts for all products (tickets) associated with an event.
 * Returns an array of { product_id, product_name, total_quantity, used_quantity, reserved_quantity, location_id, location_name }
 */
export async function getEventInventory(eventId) {
  const { data, errors } = await httpClient.get({
    url: `v1/community-portal/inventory/event/${eventId}`,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

/**
 * Step 1 of the wizard: create a minimal event row + draft_events record.
 * Returns { event_id } to be stored in wizard state for subsequent steps.
 */
export async function initDraftPortalEvent(body) {
  const { data, errors } = await httpClient.post({
    url: "v1/community-portal/event/init",
    body,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

/**
 * Steps 2–5: persist current form state into draft_events.data so the user
 * can resume from where they left off.
 */
export async function updateDraftPortalEvent(eventId, body) {
  const { data, errors } = await httpClient.patch({
    url: `v1/community-portal/event/draft/${eventId}`,
    body,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

/**
 * Load saved draft form state for a given event (resume flow).
 * Returns { event_id, data, current_step }.
 */
export async function getDraftPortalEvent(eventId) {
  const { data, errors } = await httpClient.get({
    url: `v1/community-portal/event/draft/${eventId}`,
  });
  if (errors && errors.length > 0) return { data: null, errors };
  return { data };
}

/**
 * List all in-progress wizard drafts for the authenticated vendor.
 * Returns array of { event_id, title, current_step, created_at, updated_at }.
 */
export async function listDraftPortalEvents() {
  const { data, errors } = await httpClient.get({
    url: "v1/community-portal/event/drafts",
  });
  if (errors && errors.length) return { data: null, errors };
  return { data };
}

/**
 * Delete an IN_PROGRESS draft — removes the event row and draft_events record.
 */
export async function deleteDraftPortalEvent(eventId) {
  const { data, errors } = await httpClient.delete({
    url: `v1/community-portal/event/draft/${eventId}`,
  });
  if (errors && errors.length) return { data: null, errors };
  return { data };
}
